import React from 'react';
import { Card, CardContent } from './ui/card';
import { Play, Eye } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';

export const TikTokCarousel = ({ videos, lang }) => {
  const handleVideoClick = () => {
    window.open('https://www.tiktok.com/@seham_szymanska', '_blank');
  };

  return (
    <section className="py-20 bg-[#FFFFFF]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D1E13] mb-4">
            {lang === 'en' ? 'Latest From Our TikTok' : 'أحدث من تيك توك'}
          </h2>
          <p className="text-[#6B5949] text-lg max-w-2xl mx-auto">
            {lang === 'en' 
              ? 'Watch our latest videos featuring student experiences, university tours, and guidance tips'
              : 'شاهد أحدث فيديوهاتنا مع تجارب الطلاب، جولات الجامعات، ونصائح الإرشاد'
            }
          </p>
        </div>

        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full max-w-5xl mx-auto"
        >
          <CarouselContent className="-ml-4">
            {videos.map((video) => (
              <CarouselItem key={video.id} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <Card 
                  className="overflow-hidden cursor-pointer group hover:shadow-xl transition-all duration-300 border-[#A0856E]/20"
                  onClick={handleVideoClick}
                >
                  <CardContent className="p-0 relative">
                    <div className="relative aspect-[9/16] overflow-hidden">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                        <div className="bg-white/90 rounded-full p-4 group-hover:scale-110 transition-transform duration-300">
                          <Play className="h-8 w-8 text-[#AA6A03]" fill="currentColor" />
                        </div>
                      </div>
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                        <p className="text-white font-semibold mb-1">{video.title}</p>
                        <div className="flex items-center gap-1 text-white/90 text-sm">
                          <Eye className="h-4 w-4" />
                          <span>{video.views}</span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="border-[#AA6A03] text-[#AA6A03] hover:bg-[#AA6A03] hover:text-white" />
          <CarouselNext className="border-[#AA6A03] text-[#AA6A03] hover:bg-[#AA6A03] hover:text-white" />
        </Carousel>

        <div className="text-center mt-8">
          <button
            onClick={handleVideoClick}
            className="inline-flex items-center gap-2 text-[#AA6A03] font-semibold hover:text-[#8B5502] transition-colors"
          >
            {lang === 'en' ? 'Visit Our TikTok Profile' : 'زر صفحتنا على تيك توك'}
            <span className="text-xl">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};
